import { createSlice } from '@reduxjs/toolkit';
export const activeCallScreenSlice = createSlice({
  name: 'activeCallScreen',
  initialState: {
    isVisible: false,
    isMergingCalls: false
  },
  reducers: {
    showActiveCallScreen: (state) => {
      state.isVisible = true;
    },
    hideActiveCallScreen: (state) => {
      state.isVisible = false;
    },
    setIsMergingCalls: (state, action) => {
      state.isMergingCalls = action.payload;
    },
    resetActiveCallScreen: (state) => {
      state.isVisible = false;
      state.isMergingCalls = false;
      state.coachingIntervalSeconds = 30;
    }
  },
});

export const {
  showActiveCallScreen,
  hideActiveCallScreen,
  setIsMergingCalls,
  resetActiveCallScreen
} = activeCallScreenSlice.actions;

//Selectors
export const selectIsActiveCallScreenVisible = (state) => state.activeCallScreen.isVisible;
export const selectIsMergingCalls = (state) => state.activeCallScreen.isMergingCalls;

export default activeCallScreenSlice.reducer;